// extracted by mini-css-extract-plugin
export var centerText = "_53-8";
export var container = "_53-0";
export var doughnutContainer = "_53-7";
export var legend = "_53-a";
export var legendItemColorDisplay = "_53-b";
export var legendItemLabel = "_53-d";
export var legendItemValue = "_53-c";
export var lg = "_53-5";
export var maxWidth = "_53-9";
export var md = "_53-4";
export var responsive = "_53-6";
export var sm = "_53-3";
export var xs = "_53-2";
export var xxs = "_53-1";